document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".product-slider");
  const slides = slider.querySelectorAll(".product-slide");
  const prevButton = slider.querySelector(".previous-button");
  const nextButton = slider.querySelector(".next-button");

  let slideToShow = 0;

  function showSlide(index, prevIndex, dir) {
    if (dir === "prev") {
      slides[prevIndex]
        .querySelector(".slider-img")
        .classList.add("!rotate-12", "opacity-0", "duration-1000"); // Image out
    } else {
      slides[prevIndex]
        .querySelector(".slider-img")
        .classList.add("!-rotate-12", "opacity-0", "duration-1000"); // Image out
    }

    setTimeout(() => {
      slides[index]
        .querySelector(".slider-img")
        .classList.remove("duration-1000");
    }, 950);

    setTimeout(() => {
      slides[index].querySelector(".slider-img").classList.add("duration-1000");
      slides[index]
        .querySelector(".slider-img")
        .classList.remove("!-rotate-12", "!rotate-12", "opacity-0"); // Image in
    }, 50);

    slides[index].classList.remove("opacity-0", "pointer-events-none");
    slides[prevIndex].classList.add("opacity-0", "pointer-events-none");
  }

  prevButton.addEventListener("click", function () {
    currSlide = slideToShow;
    slideToShow = (slideToShow - 1 + slides.length) % slides.length;

    slides[slideToShow]
      .querySelector(".slider-img")
      .classList.remove("!-rotate-12", "!rotate-12", "duration-1000");
    slides[slideToShow]
      .querySelector(".slider-img")
      .classList.add("!-rotate-12", "opacity-0"); // Image in
    showSlide(slideToShow, currSlide, "prev");
  });

  nextButton.addEventListener("click", function () {
    currSlide = slideToShow;
    slideToShow = (slideToShow + 1) % slides.length;

    slides[slideToShow]
      .querySelector(".slider-img")
      .classList.remove("!-rotate-12", "!rotate-12", "duration-1000");
    slides[slideToShow]
      .querySelector(".slider-img")
      .classList.add("!rotate-12", "opacity-0"); // Image in
    showSlide(slideToShow, currSlide, "next");
  });
});
